export default __webpack_public_path__ + "static/media/link_black.3e1e5ef0.svg";